module.exports = __webpack_public_path__ + "img/play-mask@2x.dacf5a2a.png";